import { Button } from 'featureSliced/entities/Button'
import {
  DontHaveAccountText,
  LoginSuggestionContainer,
  LoginToProceedText,
} from './styled'
import { useOpenModal } from 'featureSliced/shared/hooks/useOpenModal'
import { AuthModal } from 'featureSliced/features/AuthModal'
import { FC } from 'react'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'

type LoginSuggestionProps = {
  moveToCredentials: () => void
}

export const LoginSuggestion: FC<LoginSuggestionProps> = ({
  moveToCredentials,
}) => {
  const t = useTranslations()
  const openModal = useOpenModal()

  const openSignupModal = (initialPage: 'login' | 'signup' = 'login') => {
    openModal({
      id: 'AUTH_MODAL',
      components: [
        () => (
          <AuthModal initialPage={initialPage} onLogin={moveToCredentials} />
        ),
      ],
    })
  }

  return (
    <LoginSuggestionContainer>
      {/* TODO: translations */}
      <LoginToProceedText>{t('auth.loginToProceed')}</LoginToProceedText>
      <Button
        buttonType="common"
        width="75vw"
        onClick={openSignupModal}
        height="50px"
      >
        {t('auth.iHaveAnAccount')}
      </Button>
      <Button
        buttonType="dark"
        width="75vw"
        onClick={moveToCredentials}
        height="50px"
      >
        {t('buttons.skip')}
      </Button>
      <DontHaveAccountText onClick={() => openSignupModal('signup')}>
        {t('auth.dontHaveAnAccount')}
      </DontHaveAccountText>
    </LoginSuggestionContainer>
  )
}
